/* 布局 */
//前台
import Layout from "@views/layout";

const orderburyattachedRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "orderburyattached/list",
        name: "ORDERBURYATTACHED",
        meta: {
            title: "殡葬用品订单附表",
            keepAlive:true
        },
        component: () => import("@views/business/orderburyattached/index.vue"),
    },
        ],
};

export default orderburyattachedRouter;
